import { putOneDigitalAdvisor, setAsPrimary } from './index';

describe('OneDigital redux reducers', () => {
  const state = {
    planDesign: {
      questions: {
        advisorCompensation: { options: [{ label: '' }, { label: '' }] },
        advisorFee: {},
        investmentLineup: {},
        hasTpa: { options: [{ valueFormatted: '' }, { valueFormatted: '' }] },
        advisorType: { options: [{ label: '' }, { label: '' }] },
        advisorPoints: {},
        hasFp: { options: [{ label: '' }, { label: '' }] },
        firmNameFreeForm: {},
        advisorFirmBroker: {},
      },
      advisors: [
        {
          advisorIndex: 1,
          questions: {
            advisorEmail: {
              value: 'Weston.staples@onedigital.com',
            },
          },
        },
        {
          advisorIndex: 0,
          questions: {
            advisorEmail: {
              value: 'Anthony.john@onedigital.com',
            },
          },
        },
      ],
    },
  };

  test('putOneDigitalAdvisor', () => {
    expect(putOneDigitalAdvisor(state)).toEqual({
      planDesign: expect.objectContaining({
        advisors: expect.arrayContaining([
          expect.objectContaining({ advisorIndex: 1 }),
          expect.objectContaining({
            questions: expect.objectContaining({
              advisorEmail: expect.objectContaining({
                value: 'britt.wells+onedigitalAJ@shiftdsm.com',
              }),
            }),
          }),
        ]),
      }),
    });
  });

  test('array of advisors is successfully returned', () => {
    expect(setAsPrimary(state, { advisorIndex: 1 })).toEqual({
      planDesign: {
        questions: {
          advisorCompensation: { options: [{ label: '' }, { label: '' }] },
          advisorFee: {},
          investmentLineup: {},
          hasTpa: { options: [{ valueFormatted: '' }, { valueFormatted: '' }] },
          advisorType: { options: [{ label: '' }, { label: '' }] },
          advisorPoints: {},
          hasFp: { options: [{ label: '' }, { label: '' }] },
          firmNameFreeForm: {},
          advisorFirmBroker: {},
        },
        advisors: [
          {
            advisorIndex: 0,
            questions: {
              advisorEmail: {
                value: 'Anthony.john@onedigital.com',
              },
            },
          },
          {
            advisorIndex: 1,
            questions: {
              advisorEmail: {
                value: 'Weston.staples@onedigital.com',
              },
            },
          },
        ],
      },
    });
  });

  test('array of advisors are reordered', () => {
    expect(setAsPrimary(state, { advisorIndex: 0 })).toEqual({
      planDesign: expect.objectContaining({
        advisors: expect.arrayContaining([
          expect.objectContaining({ advisorIndex: 1 }),
          expect.objectContaining({
            questions: expect.objectContaining({
              advisorEmail: expect.objectContaining({
                value: 'Anthony.john@onedigital.com',
              }),
            }),
          }),
        ]),
      }),
    });
  });
});
